import React from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import {
    FootNote,
    SizeCell,
    SplitCaKingCell,
    SplitKingCell,
    sizeIcons,
} from "./_shared";

import styles from "../../../styles/composable/product-specifications.module.scss";

/**
 * Native port of ``cms/blocks/product-specifications/luxeadapt.html`` (#33410).
 * Six size cells (no Twin / Full/Double), LuxeAdapt weight ranges.
 */
export const LuxeAdapt = (): React.JSX.Element => (
    <div
        className={concatClassNames([
            "adapt-specifications",
            styles.specifications,
        ])}
    >
        <SizeCell
            icon={sizeIcons.adaptTwinXl}
            heading="Twin Long"
            lines={['38" x 80"', "Single Mattress", "61-90 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptQueen}
            heading="Queen"
            lines={['60" x 80"', "Single Mattress", "94-141 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptKing}
            heading="King"
            lines={['76" x 80"', "Single Mattress", "118-179 lbs"]}
        />
        <SplitKingCell
            lines={['76" x 80"', "Double Mattress", "122-180 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptCaKing}
            heading="CA King"
            lines={['72" x 84"', "Single Mattress", "118-179 lbs"]}
        />
        <SplitCaKingCell
            lines={['72" x 84"', "Double Mattress", "124-182 lbs"]}
        />

        <FootNote />
    </div>
);
